import React from "react";

const steps = [
  {
    number: "01",
    title: "O contato chama no WhatsApp",
    text: "A Sengia interpreta a solicitação e consulta as informações disponíveis da sua empresa.",
    icon: "fa fa-whatsapp",
  },
  {
    number: "02",
    title: "O agente responde e executa",
    text: "Além de orientar, ele realiza tarefas autorizadas, como agendar ou abrir um protocolo.",
    icon: "fa fa-magic",
  },
  {
    number: "03",
    title: "Sua equipe acompanha",
    text: "Quando necessário, uma pessoa assume a conversa com o histórico e o contexto preservados.",
    icon: "fa fa-users",
  },
];

export const HowItWorks: React.FC = () => (
  <section id="como-funciona" className="relative overflow-hidden bg-slate-950 py-24">
    <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-blue-600/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-cyan-500/10 blur-3xl" />
    <div className="relative mx-auto max-w-6xl px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cyan-300">
          Como funciona
        </p>
        <h2 className="mt-4 text-3xl font-semibold text-white sm:text-4xl">
          Da primeira mensagem à tarefa concluída
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">
          IA e atendimento humano trabalham no mesmo fluxo para que cada
          conversa avance com clareza.
        </p>
      </div>

      <ol className="mt-14 grid gap-6 lg:grid-cols-3">
        {steps.map((step) => (
          <li
            key={step.number}
            className="relative rounded-3xl border border-white/10 bg-white/[0.06] p-7 backdrop-blur-sm"
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold tracking-[0.2em] text-cyan-300">
                {step.number}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-500/20 text-blue-200">
                <i className={`${step.icon} text-xl`} aria-hidden="true" />
              </span>
            </div>
            <h3 className="mt-8 text-xl font-semibold text-white">
              {step.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">
              {step.text}
            </p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
